import React from 'react'

import PropTypes from 'prop-types'

const ErrorMessage = ({domain, ...props}) => {
  const config = domain.get('config')
  const urlStatics = config.get('urlStatics')
  const imgUrl = `${urlStatics}images/no-results.svg`
  const {text} = props

  return (
    <figure className="mt-ErrorMessage">
      <img className="mt-ErrorMessage-image" src={imgUrl} alt={text} />
      <figcaption className="mt-ErrorMessage-text">{text}</figcaption>
    </figure>
  )
}

ErrorMessage.displayName = 'ErrorMessage'

ErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
  domain: PropTypes.object
}

export default ErrorMessage
